/**
 * Created by glenn on 3/22/2017.
 */
import {combineReducers, createStore, Action} from 'redux'


export const ACTION_SET_EXTENT = 'SET_EXTENT';
export const ACTION_ClEAR_EXTENT = 'CLEAR_EXTENT';
export const ACTION_SET_START_DATE = 'SET_START_DATE';
export const ACTION_SET_END_DATE = 'SET_END_DATE';
export const ACTION_SET_MAP = 'set map';
export const ACTION_SET_ROADS = 'set roads';
export const ACTION_SET_LAYERS = 'set layers';
export const ACTION_SET_SLIDER = 'set slider';
export const ACTION_SET_DATA = 'set data';
export const ACTION_SET_SORTED = 'set sorted';
export const ACTION_SET_VEHICLE = 'set vehicle';
export const ACTION_SET_WAITING = 'set waiting';
export const ACTION_SET_VERSION = 'set version';


interface iSetExtent extends Action {
    polygon: Object;
}

interface iSetDate extends Action {
    dte: string;
}

export function setExtent(ext?: Object): iSetExtent {
    if (ext) {
        return {
            type: ACTION_SET_EXTENT,
            polygon: ext
        }
    } else {
        return {
            type: ACTION_ClEAR_EXTENT,
            polygon: undefined
        }
    }
}

export function setStartDate(dte: string): iSetDate {
    return {
        type: ACTION_SET_START_DATE,
        dte: dte
    }
}

export function setEndDate(dte: string): iSetDate {
    return {
        type: ACTION_SET_START_DATE,
        dte: dte
    }
}

function startDate(state = '', action: iSetDate) {
    if (action.type == ACTION_SET_START_DATE && action.dte !== state) {
        return action.dte;
    } else {
        return state;
    }
}

function endDate(state = '', action: iSetDate) {
    if (action.type == ACTION_SET_END_DATE && action.dte !== state) {
        return action.dte;
    } else {
        return state;
    }
}

function extent(state=null, action: iSetExtent){
    switch(action.type){
        case ACTION_SET_EXTENT:
            return action.polygon;
        case ACTION_ClEAR_EXTENT:
            return null;
        default:
            return state;
    }
}

const appAll = combineReducers({startDate, endDate, extent});

export const store = createStore(appAll);

